import React from "react";
import ReactDOM from "react-dom";
import App from "./app";
import reportWebVitals from "./reportWebVitals";
import axios from "axios";
import PATH from "routing/path";
import { createBrowserHistory } from "history";
import { matchPath } from "react-router-dom";
import "styles/global.css";
import Cookies from "universal-cookie";
import { Constants } from "utils/constants/constants";
const history = createBrowserHistory();

const cookies = new Cookies();

// Clear user-app cookies set on the parent .crono.one domain so they don't
// interfere with admin auth (the backend would otherwise authenticate the
// request with the user JWT and reject the admin login as 401).
cookies.remove("access_token", { domain: ".crono.one", path: "/" });
cookies.remove("XSRF-TOKEN", { domain: ".crono.one", path: "/" });

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error?.response?.status === 401) {
      const returnUrl = window.location.pathname;
      if (!matchPath(returnUrl, PATH.LOGIN)) {
        localStorage.clear();
        cookies.remove(Constants.cronoAdminSessionCookie);
        history.push(`${PATH.LOGIN}?returnUrl=${returnUrl}`);
      }
    }

    return Promise.reject(error);
  },
);

ReactDOM.render(
  <React.StrictMode>
    <App history={history} />
  </React.StrictMode>,
  document.getElementById("root"),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
